module.exports = __webpack_public_path__ + "img/logoLoadingGray.47742702.png";